module.exports = __webpack_public_path__ + "static/media/armaan-profile.a4552b48.png";